export default __webpack_public_path__ + "static/media/demo.63944b6a.jpg";